<ngb-alert
  class="love-it-alert"
  [type]="type"
  [dismissible]="false"
  ><i [data-feather]="icon"></i>
  <ng-content></ng-content>
</ngb-alert>
